import { CuteIcon } from '@/shared/components/CuteIcon'
interface TodayStatusHeaderProps {
  referenceAt: string
  timeZone: string
}

function formatTodayDate(referenceAt: string, timeZone: string): string {
  const date = new Date(referenceAt)
  const monthAndDay = new Intl.DateTimeFormat('zh-CN', {
    month: 'long',
    day: 'numeric',
    timeZone,
  }).format(date)
  const weekday = new Intl.DateTimeFormat('zh-CN', {
    weekday: 'long',
    timeZone,
  }).format(date)
  return `${monthAndDay} · ${weekday}`
}

export function TodayStatusHeader({ referenceAt, timeZone }: TodayStatusHeaderProps) {
  return (
    <div className="today-page__header">
      <div>
        <p className="today-page__eyebrow">{formatTodayDate(referenceAt, timeZone)}</p>
        <h1 id="today-title">今日状态 <span aria-hidden="true"><CuteIcon name="flower" /></span></h1>
      </div>
      <span className="today-page__companion" aria-hidden="true"><CuteIcon name="heart" size={38} /></span>
    </div>
  )
}
